import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/page.tsx");
